import React, { useMemo } from "react";
import { useParams } from "react-router-dom";

import { useDictionary } from "hooks";
import Helper from "./helpers";

import { HAPLO_REPOSITORY_API } from "globals/constants";

import IntegrationComponent from "components/flowable/Integration/IntegrationComponent";

const HaploRepository = props => {
	const { onChange, onEvent, config } = props;

	const params = useParams();
	const dictionary = useDictionary("haploRepositoryIntegration");

	config.value = params.proposalId ?? params.awardId;

	const haploRepositoryDictionary = useMemo(() => {
		return {
			headline: dictionary?.headline || "Link to Costing Tool",
			description: dictionary?.description,
			noData: dictionary?.noData ?? "No Repository records are linked to this SP record. Links can be created from the desired Repository record as applicable.",
			errorMessage: dictionary?.errorMessage,
			infoText: dictionary?.infoText
		}
	}, [ dictionary ]);

	const cardKeys = useMemo(() => {
		return {
			title: dictionary?.title ?? "Repository record Title",
			type:  dictionary?.startDate ?? "Type",
			authors:  dictionary?.authors ?? "Duration",
			ingestStatus:  dictionary?.status ?? "Status"
		}
	}, [ dictionary ]);

	return (
		<IntegrationComponent
			helper={Helper}
			url={HAPLO_REPOSITORY_API}
			cardKeys={cardKeys}
			dictionary={haploRepositoryDictionary}
			config={config}
			onChange={onChange}
			onEvent={onEvent}
		/>
	);
};

export default HaploRepository;
